import type { Database } from '@noconflict/contracts';
import { createClient } from '@supabase/supabase-js';
import { env } from '../config/env';

export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey);
export type Supabase = typeof supabase;
